'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import e from "../defs/Sparkle.js";
var f = Object.defineProperty, i = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var a = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var t = (r, e2, o) => e2 in r ? f(r, e2, { enumerable: true, configurable: true, writable: true, value: o }) : r[e2] = o, m = (r, e2) => {
  for (var o in e2 || (e2 = {}))
    c.call(e2, o) && t(r, o, e2[o]);
  if (a)
    for (var o of a(e2))
      l.call(e2, o) && t(r, o, e2[o]);
  return r;
}, p = (r, e2) => i(r, s(e2));
const I = forwardRef((r, e$1) => /* @__PURE__ */ a__default.createElement(b, p(m({ ref: e$1 }, r), { weights: e })));
I.displayName = "Sparkle";
export {
  I as Sparkle
};
